
import React from "react";
// import { LoadingButton } from "@mui/lab";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";


function LoadingBtn({ text, loading,disabled, type = "button", onClick, sx = {} }) {
  // console.log({disabled});
  
  return (
    <Button
      type={type}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      variant="contained"
      sx={{
        height: "40px",
        width: "100px",
        borderRadius: "10px",
        fontWeight: "500",
        color: "White",
        "&.Mui-disabled": {
          backgroundColor: "#e0e0e0",
          color: "#9e9e9e",
        },
        ...sx, 
      }}
    >
      {text}
    </Button>
  );
}

export default LoadingBtn;
